import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { avatars } from '../styles/designTokens';
import './UserProfile.css';

const UserProfile: React.FC = () => {
  const { userProfile, updateProfile } = useTheme();
  const [isEditing, setIsEditing] = useState(false);
  const [editProfile, setEditProfile] = useState(userProfile);

  const handleSave = () => {
    updateProfile(editProfile);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditProfile(userProfile);
    setIsEditing(false);
  };

  return (
    <div className="user-profile glass-card">
      <div className="profile-header">
        <h3 className="profile-title">👤 Мой профиль</h3>
        <button 
          className="edit-btn"
          onClick={() => setIsEditing(!isEditing)}
        >
          {isEditing ? '❌' : '✏️'}
        </button>
      </div>

      <div className="profile-content">
        <div className="avatar-section">
          <div className="avatar-large animate-float">
            {userProfile.avatar}
          </div>
          {isEditing && (
            <div className="avatar-selector">
              <h4>Выберите аватар:</h4>
              <div className="avatar-grid">
                {avatars.map((avatar, index) => (
                  <button
                    key={index}
                    className={`avatar-option ${editProfile.avatar === avatar ? 'selected' : ''}`}
                    onClick={() => setEditProfile({...editProfile, avatar})}
                  >
                    {avatar}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="profile-info">
          {isEditing ? (
            <div className="edit-form">
              <input
                type="text"
                value={editProfile.name}
                onChange={(e) => setEditProfile({...editProfile, name: e.target.value})}
                className="profile-input"
                placeholder="Ваше имя"
              />
              <textarea
                value={editProfile.bio}
                onChange={(e) => setEditProfile({...editProfile, bio: e.target.value})}
                className="profile-textarea"
                placeholder="Расскажите о себе..."
                rows={3}
              />
              <div className="profile-actions">
                <button onClick={handleSave} className="save-btn">
                  💾 Сохранить
                </button>
                <button onClick={handleCancel} className="cancel-btn">
                  🚫 Отмена
                </button>
              </div>
            </div>
          ) : (
            <div className="profile-display">
              <h4 className="profile-name animate-fade-in-up">{userProfile.name}</h4>
              <p className="profile-bio animate-fade-in-up">{userProfile.bio}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
